// When Reset all shows. Only effects bring it out: two or more audio and video
// effects together, or any one ambient effect. Speed, Slow ⇄ Fast and pitch
// never do on their own. Once out, it stays until every control is back at
// its default (areControlsAtDefaults), which is also what it resets to.
const AUDIO_EFFECTS = [
  "lowPassMode",
  "highPassMode",
  "lofiTapeMode",
  "bitcrusherMode",
  "vinylCrackleMode",
  "bassBoostMode",
  "phaserMode",
  "echoMode",
  "trunkMode",
];

const AMBIENT_EFFECTS = [
  "rainyMode",
  "coffeeShopMode",
  "seashoreMode",
  "berghainMode",
  "fireplaceMode",
  "hotelLoungeMode",
  "cocktailBarMode",
];

export function shouldShowResetAll(controls = {}) {
  if (AMBIENT_EFFECTS.some((key) => controls[key])) return true;

  const audioAndVideo =
    AUDIO_EFFECTS.filter((key) => controls[key]).length +
    (controls.reverbAmount > 0 ? 1 : 0) +
    (controls.videoFx ? 1 : 0);
  return audioAndVideo >= 2;
}

export function areControlsAtDefaults(controls = {}) {
  return (
    (controls.slowControl ?? 1) === 1 &&
    !(controls.reverbAmount > 0) &&
    !controls.videoFx &&
    !controls.speedUpMode &&
    !controls.preservePitchMode &&
    ![...AUDIO_EFFECTS, ...AMBIENT_EFFECTS].some((key) => controls[key])
  );
}
